import AccountHelper from 'features/Account/accountHelper';
import AgencyHelper from 'features/Agency/agencyHelper';
import AuthHelper from 'features/Auth/authHelper';
import { resetAuthSlice } from 'features/Auth/authSlice';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import MaintainerAuthHelper from 'features/Maintainer/MaintainerAuth/maintainerAuthHelper';
import { resetAgencyState } from 'features/ManageDealer/agencySlice';
import SystemHelper from 'features/System/systemHelper';
import { AnimatePresence, motion } from 'framer-motion';
import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTTooltip, { KTTooltipPositions } from 'general/components/OtherKeenComponents/KTTooltip';
import AdvanceNavMenu from 'general/components/quybka/Others/AdvanceNavMenu';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useOnClickOutside from 'hooks/useOnClickOutside';
import useRouter from 'hooks/useRouter';
import { useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

ButtonAccountDropdownInfo.propTypes = {};

function ButtonAccountDropdownInfo(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const userRoleName = useMemo(() => {
    if (user?.role !== ChargeConstants.UserRole.AGENCY) {
      return ChargeHelper.Utils.getUserRoleName(user?.role);
    } else {
      if (!user?.agency?.parentAgencyId) {
        return 'Tổng đại lý';
      }
      return AgencyHelper.Utils.getAgencyRoleName(user?.agency?.primaryRole);
    }
  }, [user]);
  const [showDropdown, setShowDropdown] = useState(false);
  const refDropdown = useRef(null);
  useOnClickOutside(refDropdown, () => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  });

  return (
    <div className="position-relative" ref={refDropdown}>
      <div
        className="d-flex align-items-center gap-3 cursor-pointer hover-opacity-60"
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
      >
        <div className="d-flex flex-column align-items-end">
          <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
            {user?.fullname ?? ''}
          </span>
          <div className="d-flex align-items-center gap-1">
            <span style={UIHelper.buildFontStyle('400', '14px', AppColors.primary)}>
              {userRoleName}
            </span>
            {!isAdmin && !!user?.agency?.parentAgencyId && (
              <>
                <KTTooltip
                  position={KTTooltipPositions.auto}
                  text="<span>Số tiền được trả cho bạn thông qua hoạt động bán hàng, đầu tư, cho thuê,...<br />Bạn có thể rút tiền về tài khoản thông qua tính năng “Rút tiền về tài khoản”.</span>"
                  textHeader="Số dư ví của bạn"
                  isHtmlContent
                >
                  <span style={UIHelper.buildFontStyle('400', '14px', AppColors.primary)}>
                    • {Utils.formatNumber(user?.agency?.balance)} VNĐ
                  </span>
                </KTTooltip>
              </>
            )}
          </div>
        </div>
        <div>
          {UIHelper.buildAvatar(
            user?.avatar ? Utils.getFullUrl(user?.avatar) : null,
            40,
            AppResource.icons.avatar.default,
            false,
            false,
            10
          )}
        </div>
      </div>
      {/* dropdown info */}
      <AnimatePresence mode="wait">
        <motion.div
          key={showDropdown}
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -10, opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          {showDropdown && (
            <div
              className="bg-white position-absolute top-100 right-0 shadow"
              style={{
                borderRadius: '5px',
                minWidth: '240px',
                marginTop: '10px',
              }}
            >
              {/* caret */}
              <div
                className="dropdown-caret position-absolute"
                style={{
                  top: '-10px',
                  right: '20px',
                  width: '0',
                  height: '0',
                  borderLeft: '10px solid transparent',
                  borderRight: '10px solid transparent',
                  borderBottom: `10px solid white`,
                }}
              ></div>
              {/* header */}
              <div className="d-flex flex-column align-items-start p-4 gap-3">
                <div
                  className=""
                  style={{
                    padding: '4px',
                    borderRadius: '5px',
                    border: `1px solid ${AppColors.gray[200]}`,
                  }}
                >
                  {UIHelper.buildAvatar(
                    user?.avatar ? Utils.getFullUrl(user?.avatar) : null,
                    62,
                    AppResource.icons.avatar.default,
                    false,
                    false,
                    2
                  )}
                </div>
                <div className="d-flex flex-column gap-1">
                  <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[900])}>
                    {user?.fullname ?? ''}
                  </span>
                  <KTLabel
                    text={userRoleName}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-success `}
                  />
                </div>
              </div>
              {/* menu */}
              <div
                className="py-2"
                style={{
                  borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
              >
                <AdvanceNavMenu
                  itemList={[
                    {
                      text: 'Cài đặt tài khoản',
                      iconElement: <i className="fa-regular fa-user" />,
                      active: false,
                      disabled: false,
                      onClick: () => {
                        setShowDropdown(false);
                        SystemHelper.UI.Account.showDialogUpdateAccountInfo(user, () => {
                          AccountHelper.callApiGetProfile();
                        });
                      },
                    },
                    {
                      text: 'Đổi mật khẩu',
                      iconElement: <i className="fa-regular fa-lock" />,
                      active: false,
                      disabled: false,
                      onClick: () => {
                        setShowDropdown(false);
                        SystemHelper.UI.Account.showDialogChangePassword(() => { });
                      },
                    },
                    {
                      text: 'Đăng xuất',
                      iconElement: <i className="fa-regular fa-right-from-bracket" />,
                      active: false,
                      disabled: false,
                      onClick: () => {
                        setShowDropdown(false);
                        SystemHelper.UI.Account.showDialogConfirmSignOut(() => {
                          AuthHelper.signOut();
                          dispatch(resetAuthSlice());
                          dispatch(resetAgencyState());
                          if (user?.role === AppConstants.userRole.maintainer) {
                            router.navigate(AppRoute.maintainerAuth);
                          } else {
                            router.navigate(AppRoute.auth);
                          }
                        });
                      },
                    },
                  ]}
                  enableHoverStyle={true}
                  enableActiveStyle={true}
                />
              </div>
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default ButtonAccountDropdownInfo;
